import React, { useRef } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    Container,
    Grid,
    Card,
    CardContent,
    Box,
} from "@mui/material";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import AdsClickIcon from '@mui/icons-material/AdsClick';
import InsightsIcon from '@mui/icons-material/Insights';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EditNoteIcon from "@mui/icons-material/EditNote";
import MemoryIcon from "@mui/icons-material/Memory";
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import SecurityIcon from '@mui/icons-material/Security';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import { useNavigate } from "react-router-dom";

export default function Home() {

    const howItWorksRef = useRef(null);
    const navigate = useNavigate();

    const scrollToSection = () => {
        howItWorksRef.current?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <Box>
            {/* HEADER */}
            <AppBar position="sticky" sx={{ backgroundColor: "#000000de" }} elevation={1}>
                <Toolbar sx={{ justifyContent: "space-between" }}>
                    <Box onClick={() => navigate("/")} sx={{ cursor: "pointer" }}>
                        <img src="/assets/Logo_Contblack_FundoEscuro.png" alt="Logo" />
                    </Box>

                    <Box>
                        <Button onClick={() => navigate("/finalizarPedido")} variant="contained" sx={{ backgroundColor: "#1EFF86", color: "black" }}>Diagnóstico</Button>
                    </Box>
                </Toolbar>
            </AppBar>

            {/* HERO */}
            <Container sx={{ py: 10 }}>
                <Grid container spacing={6} alignItems="center">
                    <Grid item sx={{ width: "100%", maxWidth: 600 }}>
                        <Typography variant="overline" color="primary">
                            ESTRATÉGIA COM IA
                        </Typography>

                        <Typography variant="h3" fontWeight="bold" gutterBottom>
                            Arquitete o <b style={{ color: "#1EFF86" }}>Futuro do seu Negócio Digital</b> em Minutos
                        </Typography>

                        <Typography color="text.secondary" paragraph>
                            Com nossa inteligência artificial, você cria a missão do seu negócio, analisa forças, fraquezas, oportunidades e ameaças (SWOT) e monta um plano de ação passo a passo.
                        </Typography>

                        <Box sx={{ display: "flex", gap: 2 }}>
                            <Button onClick={() => navigate("/finalizarPedido")} variant="contained" size="large" sx={{ backgroundColor: "#1EFF86", color: "black" }}>
                                Começar
                            </Button>

                            <Button variant="outlined" size="large" sx={{ backgroundColor: "transparent", color: "black", borderColor: "#1EFF86" }} onClick={scrollToSection}>
                                Ver como funciona
                            </Button>
                        </Box>
                    </Grid>

                    {/* CARD */}
                    <Grid sx={{ width: "100%", maxWidth: 500 }}>
                        <Card sx={{ borderRadius: 4 }}>
                            <CardContent>
                                <Typography variant="body1" fontWeight="bold" gutterBottom>
                                    Roteiro de Crescimento
                                </Typography>

                                <Typography variant="body2" color="text.secondary">
                                    Diagnóstico concluído • 100%
                                </Typography>

                                <Grid container sx={{ display: "flex", justifyContent: "space-between", mt: 2, flexWrap: "wrap" }} spacing={2}>
                                    <Grid sx={{ width: window.innerWidth < 500 ? "100%" : "47%", minWidth: "200px", height: "fit-content" }} item xs={6}>
                                        <Box p={2} bgcolor="#f5f5f5" borderRadius={2} sx={{ height: "120px" }} >
                                            <TrendingUpIcon fontSize="large" sx={{ verticalAlign: "middle", mb: 1, color: "#1EFF86" }} /><br />
                                            <Typography variant="body2" fontWeight="bold">
                                                Análise SWOT
                                            </Typography><br />
                                            <Typography sx={{ fontSize: "10px" }} variant="caption" fontWeight="bold">
                                                Oportunidades, Ameaças, Forças e Fraquezas
                                            </Typography>

                                        </Box>
                                    </Grid>

                                    <Grid sx={{ width: window.innerWidth < 500 ? "100%" : "47%", minWidth: "200px", height: "fit-content" }} item xs={6}>
                                        <Box p={2} bgcolor="#f5f5f5" borderRadius={2} sx={{ height: "120px" }} >
                                            <RocketLaunchIcon fontSize="large" sx={{ verticalAlign: "middle", mb: 1, color: "#1EFF86" }} /><br />
                                            <Typography variant="body2" fontWeight="bold">
                                                Missão, Visão & Valores
                                            </Typography><br />
                                            <Typography sx={{ fontSize: "10px" }} variant="caption" fontWeight="bold">
                                                Propósito, Futuro Ideal e Princípios
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>

            {/* FEATURES */}
            <Box sx={{ bgcolor: "#f5f5f5", py: 10 }}>
                <Container size="md" >
                    <Typography variant="h4" fontWeight="bold" align="center" mb={6}>
                        O que você vai receber?
                    </Typography>

                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "20px", backgroundColor: "#f5f5f5", padding: "24px", boxSizing: "border-box", }} >
                        <div style={{ width: window.innerWidth < 500 ? "100%" : "40%", height: window.innerWidth < 500 ? "auto" : "250px", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", }} >
                            <div style={{ padding: "20px 20px 0 20px", }} >
                                <AdsClickIcon fontSize="large" sx={{ color: "#1EFF86" }} />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", padding: "12px 20px", gap: "8px", }} >
                                <h1 style={{ margin: 0, fontSize: "20px", color: "#333" }}>
                                    Missão, Visão & Valores
                                </h1>
                                <p style={{ margin: 0, color: "#666", lineHeight: "1.5" }}>
                                    Articule seu propósito e horizonte de longo prazo com precisão logística que inspira investidores.
                                </p>
                            </div>
                        </div>
                        <div style={{ width: window.innerWidth < 500 ? "100%" : "55%", height: window.innerWidth < 500 ? "auto" : "250px", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", }} >
                            <div style={{ padding: "20px 20px 0 20px", }} >
                                <InsightsIcon fontSize="large" sx={{ color: "#1EFF86" }} />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", padding: "12px 20px", gap: "8px", }} >
                                <h1 style={{ margin: 0, fontSize: "20px", color: "#333" }}>
                                    SWOT Avançado
                                </h1>
                                <p style={{ margin: 0, color: "#666", lineHeight: "1.5" }}>
                                    Um mergulho profundo e preciso em Forças, Fraquezas, Oportunidades e Ameaças, revelando insights estratégicos que guiam decisões de alto impacto.
                                </p>
                                <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", flexDirection: "column", gap: "4px", marginTop: "8px" }}>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Análise de Cenário</span>
                                    </div>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Identificação de Vantagens Competitivas</span>
                                    </div>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Otimização de Recursos</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "20px", backgroundColor: "#f5f5f5", padding: "24px", boxSizing: "border-box", }} >
                        <div style={{ width: window.innerWidth < 500 ? "100%" : "55%", height: window.innerWidth < 500 ? "auto" : "350px", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", }} >
                            <div style={{ padding: "20px 20px 0 20px", }} >
                                <RoomPreferencesIcon fontSize="large" sx={{ color: "#1EFF86" }} />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", padding: "12px 20px", gap: "8px", }} >
                                <h1 style={{ margin: 0, fontSize: "20px", color: "#333" }}>
                                    Benchmarks
                                </h1>
                                <p style={{ margin: 0, color: "#666", lineHeight: "1.5" }}>
                                    Crescer no mercado digital sem referência é andar no escuro. Os benchmarks permitem entender como os melhores estão performando, quais estratégias funcionam e onde estão as oportunidades para evoluir com mais segurança e assertividade.
                                </p>
                                <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", flexDirection: "column", gap: "4px", marginTop: "8px" }}>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Compare seus resultados com padrões do mercado e entenda onde você realmente está — isso evita decisões baseadas em achismo.</span>
                                    </div>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Ao analisar concorrentes e referências, fica mais fácil enxergar o que pode ser melhorado, ajustado ou explorado no seu negócio.</span>
                                    </div>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Com dados comparativos, você reduz riscos e direciona esforços para ações que já demonstraram resultado no seu segmento.</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{ width: window.innerWidth < 500 ? "100%" : "40%", height: window.innerWidth < 500 ? "auto" : "350px", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", }} >
                            <div style={{ padding: "20px 20px 0 20px", }} >
                                <ThumbUpAltIcon fontSize="large" sx={{ color: "#1EFF86" }} />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", padding: "12px 20px", gap: "8px", }} >
                                <h1 style={{ margin: 0, fontSize: "20px", color: "#333" }}>
                                    Plano de ação
                                </h1>
                                <p style={{ margin: 0, color: "#666", lineHeight: "1.5" }}>
                                    Tenha clareza em cada etapa do seu crescimento: um plano de ação bem estruturado — com metas de curto, médio e longo prazo — é o que transforma presença digital em um negócio sólido, seguro e escalável.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", justifyContent: "center", gap: "20px", backgroundColor: "#f5f5f5", padding: "24px", boxSizing: "border-box", }} >
                        <div style={{ width: window.innerWidth < 500 ? "100%" : "48%", height: window.innerWidth < 500 ? "auto" : "290px", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", }} >
                            <div style={{ padding: "20px 20px 0 20px", }} >
                                <SecurityIcon fontSize="large" sx={{ color: "#1EFF86" }} />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", padding: "12px 20px", gap: "8px", }} >
                                <h1 style={{ margin: 0, fontSize: "20px", color: "#333" }}>
                                    Proteção e Estrutura no Mercado Digital
                                </h1>
                                <p style={{ margin: 0, color: "#666", lineHeight: "1.5" }}>
                                    No mercado digital — especialmente para criadoras de conteúdo adulto — proteger sua imagem, garantir sigilo, ter segurança jurídica e estruturar sua marca com governança não é opcional: é o que sustenta o seu crescimento.
                                </p>
                            </div>
                        </div>
                        <div style={{ width: window.innerWidth < 500 ? "100%" : "47%", height: window.innerWidth < 500 ? "auto" : "290px", backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 4px 12px rgba(0,0,0,0.08)", display: "flex", flexDirection: "column", }} >
                            <div style={{ padding: "20px 20px 0 20px", }} >
                                <SportsScoreIcon fontSize="large" sx={{ color: "#1EFF86" }} />
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", padding: "12px 20px", gap: "8px", }} >
                                <h1 style={{ margin: 0, fontSize: "20px", color: "#333" }}>
                                    Metas & KPI’s
                                </h1>
                                <p style={{ margin: 0, color: "#666", lineHeight: "1.5" }}>
                                    Sem metas claras, não existe crescimento consistente — e sem KPI’s, você não sabe se está no caminho certo. Definir indicadores e objetivos é o que transforma esforço em resultado real no mercado digital.
                                </p>
                                <div style={{ width: "100%", display: "flex", justifyContent: "flex-start", flexDirection: "column", gap: "4px", marginTop: "8px" }}>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Metas bem definidas</span>
                                    </div>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>KPI’s que importam</span>
                                    </div>
                                    <div>
                                        <CheckCircleOutlineIcon fontSize="small" sx={{ color: "green", verticalAlign: "middle", mr: 0.5 }} />
                                        <span style={{ fontSize: "12px", color: "#333" }}>Gestão orientada por dados</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </Box>

            <Box
                sx={{
                    width: "100%",
                    background: "linear-gradient(235deg, #000000de, #000000de)",
                    color: "#fff",
                    textAlign: "center",
                }}
            >
                {/* Título */}
                <Typography sx={{ fontSize: "28px", fontWeight: 700, paddingTop: "40px", color: "#1EFF86" }}>
                    Comece seu diagnóstico agora
                </Typography>

                <Typography
                    sx={{
                        fontSize: "16px",
                        opacity: 0.9,
                        marginTop: "8px",
                    }}
                >
                    Tenha sua estratégia pronta em minutos, sem complicação.
                </Typography>

                {/* Preço */}
                <Box
                    sx={{
                        marginTop: "32px",
                        marginBottom: "24px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "baseline",
                        gap: "8px",
                    }}
                >
                    <Typography sx={{ fontSize: "18px", opacity: 0.8 }}>
                        R$
                    </Typography>

                    <Typography sx={{ fontSize: "56px", fontWeight: 700, color: "#1EFF86" }}>
                        49,99
                    </Typography>

                    <Typography sx={{ fontSize: "16px", opacity: 0.8 }}>
                        pagamento único
                    </Typography>
                </Box>

                {/* Botão */}
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#1EFF86",
                        color: "black",
                        fontWeight: 700,
                        padding: "12px 32px",
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "16px",
                        "&:hover": {
                            backgroundColor: "#1EFF86",
                            color: "white",
                        },
                    }}
                    onClick={() => navigate("/finalizarPedido")}
                >
                    Começar Agora
                </Button>

                {/* Observação */}
                <Typography
                    sx={{
                        fontSize: "12px",
                        opacity: 0.7,
                        marginTop: "16px",
                        paddingBottom: "40px",
                    }}
                >
                    Acesso imediato • Sem mensalidade • Sem compromisso
                </Typography>
            </Box>

            <div style={{ width: "100%", display: "flex", justifyContent: "center", backgroundColor: "#ffffff", }} id="howItWorks" ref={howItWorksRef}>
                <Box
                    sx={{
                        width: window.innerWidth < 500 ? "100%" : "60%",
                        padding: "40px 24px",
                        boxSizing: "border-box",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                            marginBottom: "40px",
                        }}
                    >
                        <Box>
                            <Typography
                                sx={{ fontSize: "28px", fontWeight: 700, color: "#333" }}
                            >
                                Seu Diagnóstico em Três Passos
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: "16px",
                                    color: "#666",
                                    marginTop: "8px",
                                    maxWidth: "500px",
                                }}
                            >
                                Removemos o atrito do planejamento de negócios. Chega de encarar uma tela em branco.
                            </Typography>
                        </Box>

                        <Box sx={{ textAlign: "right" }}>
                            <Typography
                                sx={{
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    color: "#2e7d32",
                                    letterSpacing: "0.5px",
                                }}
                            >
                                PROCESSO ACELERADO
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: "28px",
                                    fontWeight: 700,
                                    color: "#1EFF86",
                                }}
                            >
                                ≈ 12 Minutos
                            </Typography>
                        </Box>
                    </Box>

                    {/* Steps */}
                    <Box
                        sx={{
                            display: "flex",
                            gap: "24px",
                            flexWrap: "wrap",
                        }}
                    >
                        {/* Step 1 */}
                        <Box sx={{ flex: 1, minWidth: "250px" }}>
                            <Box
                                sx={{
                                    width: "48px",
                                    height: "48px",
                                    borderRadius: "12px",
                                    backgroundColor: "#e0e0e0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "16px",
                                }}
                            >
                                <EditNoteIcon sx={{ color: "#555" }} />
                            </Box>

                            <Typography sx={{ fontWeight: 700, marginBottom: "8px" }}>
                                1. Preencha o Formulário de Contexto
                            </Typography>

                            <Typography sx={{ color: "#666", fontSize: "14px" }}>
                                Conte-nos sobre seu setor, tamanho e objetivos principais. Nosso formulário adaptativo captura a nuance da sua visão específica.
                            </Typography>
                        </Box>

                        {/* Step 2 */}
                        <Box sx={{ flex: 1, minWidth: "250px" }}>
                            <Box
                                sx={{
                                    width: "48px",
                                    height: "48px",
                                    borderRadius: "12px",
                                    backgroundColor: "#e0e0e0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "16px",
                                }}
                            >
                                <MemoryIcon sx={{ color: "#555" }} />
                            </Box>

                            <Typography sx={{ fontWeight: 700, marginBottom: "8px" }}>
                                2. Mecanismo de Síntese de IA
                            </Typography>

                            <Typography sx={{ color: "#666", fontSize: "14px" }}>
                                Nossos modelos de linguagem especializados processam seus dados contra mais de 10 milhões de padrões de negócios bem-sucedidos em tempo real.
                            </Typography>
                        </Box>

                        {/* Step 3 */}
                        <Box sx={{ flex: 1, minWidth: "250px" }}>
                            <Box
                                sx={{
                                    width: "48px",
                                    height: "48px",
                                    borderRadius: "12px",
                                    backgroundColor: "#e0e0e0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: "16px",
                                }}
                            >
                                <CheckCircleOutlineIcon sx={{ color: "#555" }} />
                            </Box>

                            <Typography sx={{ fontWeight: 700, marginBottom: "8px" }}>
                                3. Baixar e Implementar
                            </Typography>

                            <Typography sx={{ color: "#666", fontSize: "14px" }}>
                                Receba um PDF profissional. Sua estratégia está pronta para implementação imediata.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </div>



            {/* FOOTER */}
            <Box sx={{ py: 4, textAlign: "center", bgcolor: "#fafafa" }}>
                <Typography variant="body2" color="text.secondary">
                    © {new Date().getFullYear()} Análise Estratégica Contblack. Todos os direitos reservados.
                </Typography>
            </Box>
        </Box>
    );
}